// extracted by mini-css-extract-plugin
export var flowchartContainer = "_w-0";